import './i18n';
import './styles.css';
import './mock-skin.css'; // pele Odisseia: CSS verbatim do mock aprovado — carrega por último e vence
import 'flag-icons/css/flag-icons.min.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found');
}

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
